export function convertToDigits(value : string){
    return value.replace(/\D/g,"") //remove todas as letras ou caracteres especiais , deixando apenas dígitos
}